import React from "react";
import { Link } from 'gatsby'
import Seo from '../components/seo'
import { Container, Row, Col, Image } from 'react-bootstrap'
import { HomeMeta } from '../data/metaData'
import Layout from '../components/layout/layout'
// import OverlayTrigger from 'react-bootstrap/OverlayTrigger'

import { Animations } from '../components/animations'

import BannerImg from '../animations/home/Banner_BG.json'
import { StaticImage } from 'gatsby-plugin-image'
import LazyLoad from 'react-lazy-load'
import Icon1 from "../animations/web-application-development/experience_developer.json";
import Icon2 from "../animations/web-application-development/cutting_edge_technology.json";
import Icon3 from "../animations/mobile-application-development/Transparency-Communication.json";
import Icon4 from "../animations/web-application-development/on_time_delivery.json";
import Icon5 from "../animations/web-application-development/high_quality_solution.json";
import Icon6 from "../animations/web-application-development/customer_experience.json";
import Index1 from "../images/icon/index-img-1.svg";
import Index2 from "../images/icon/index-img-2.svg";
// import Index3 from "../images/icon/index-img-3.svg";
import Index4 from "../images/icon/index-img-4.svg";
import Index5 from "../images/icon/index-img-5.svg";
import Index6 from "../images/icon/index-img-6.svg";

import Index7 from "../images/icon/index-img-7.svg";

import Imageicon1 from "../images/icon/index-amazon-ecs.svg";
import Imageicon2 from "../images/icon/index-aws-lambda.svg";
import Imageicon3 from "../images/icon/index-aws-cloud.svg";
// import Imageicon4 from "../images/icon/index-cloud-watch.svg";
import Imageicon5 from "../images/icon/index-iam.svg";
import Imageicon6 from "../images/icon/index-cloud-font.svg";
import Imageicon7 from "../images/icon/index-jenkins.svg";
import Imageicon8 from "../images/icon/index-git.svg";
import Imageicon9 from "../images/icon/index-teraform.svg";
import Imageicon10 from "../images/icon/index-docker.svg";
import Imageicon11 from "../images/icon/index-grafana.svg";
import Imageicon12 from "../images/icon/index-solar.svg";

import Imageicon13 from "../images/icon/index-openai.svg";
import Imageicon14 from "../images/icon/index-aws-bedrock.svg";
import Imageicon15 from "../images/icon/index-aws-lex.svg";
import Imageicon16 from "../images/icon/index-aws-textract.svg";
import Imageicon17 from "../images/icon/index-aws-transcribe.svg";


import Scrollspy from "react-scrollspy";
import { AnchorLink } from "gatsby-plugin-anchor-links";
const ClientsTestimonial = React.lazy(() => import('../components/clients-testimonial'))
// const Facts = React.lazy(() => import('../components/facts'))
const OurClients = React.lazy(() => import('../components/our-clients-single-line-new'))
const Awards = React.lazy(() => import('../components/awards'))
const CaseStudy = React.lazy(() => import('../components/case-study'))
const BlogList = React.lazy(() => import("../components/blog/blog-list"));
const WhyChooseFacts = React.lazy(() => import('../components/why-choose-facts'))
const Faqs = React.lazy(() => import('../components/faqs'))

export const Head = () => (
  <Seo
    title={HomeMeta.metaTitle}
    description={HomeMeta.metaDescription}
    ogTitle={HomeMeta.ogTitle}
    ogDescription={HomeMeta.ogDescription}
    ogType={HomeMeta.ogType}
    ogSiteName={HomeMeta.ogSiteName}
    ogImage={HomeMeta.ogImage}
    twitterCard={HomeMeta.twitterCard}
    twitterCreator={HomeMeta.twitterCreator}
    twitterTitle={HomeMeta.twitterTitle}
    twitterDescription={HomeMeta.twitterDescription}
    twitterImage={HomeMeta.twitterImage}
  />
)

const IndexNewPage = () => {
  const HomeBannerShadow = '../images/home-banner-shadow.webp'
  const CTABgDark = '../images/bg-gradient-image.png'
  const CTABgDark1 = '../images/index-home-new-cta.png'
  // const CtaImg = '../images/home-cta-img.png'

  const Image1 = '../images/index-team-3.png'
  const Image2 = '../images/index-team-2.png'
  const Image3 = '../images/index-team-1.png'
  const Image4 = '../images/index-team-4.png'

  // const specificTitle = [
  //   "A social networking platform for all foodies to share recipes globally",
  //   "Get it delivered in minutes!",
  //   "Search, book, and commute together",
  // ];

  const choosedata = [
    {
      icon: Icon1,
      title: "Experienced team",
      des: "Being backed up by a team of expert software developers, we have a successful track record of providing efficient and effective solutions matching your exact business requirements."
    },
    {
      icon: Icon2,
      title: "Technological competitive edge",
      des: "Our company is proficient in the latest technology stack to help clients get future-ready software development solutions to meet their business objectives easily."
    },
    {
      icon: Icon3,
      title: "Effective communication",
      des: "We maintain complete transparency with our clients and keep them informed about the latest updates on their projects."
    },
    {
      icon: Icon4,
      title: "Reduced time to market",
      des: "When you hire us as your software development partner, you can be assured that you will get efficient solutions quickly so that you can reach the target users on time."
    },
    {
      icon: Icon5,
      title: "Top Quality",
      des: "We make sure that you get top-quality software from Peerbits. We are known for offering complete client satisfaction for all projects with our high coding standards."
    },
    {
      icon: Icon6,
      title: "Best value for money",
      des: "At Peerbits, we ensure that our clients get the maximum ROI for software development projects. We walk the extra mile to deliver the best solutions for our clients worldwide."
    },
  ]


  const ReliableOffshore = [
    {
      tabId: "tab1",
      title: " <span class='text-primary'>Mobile app</span> development",
      smalltitle: "Result-driven app development that serves your vision",
      des: "We specialize in creating high-quality, cross-platform mobile apps for iOS and Android. By employing an agile approach, our <a href='/mobile-application-development.html' class='text-primary'>mobile app development</a> team ensures rapid iteration and continuous improvement. Our mobile app developers utilize the latest technologies and frameworks to deliver apps with optimal performance, seamless integration, and exceptional user experience that align perfectly with your vision.",
      list: [
        {
          url: "/hire-ios-app-developer.html",
          iconclass: "ios",
          tech: "iOS",
        },
        {
          url: "/hire-android-app-developer.html",
          iconclass: "android",
          tech: "Android",
        },
        {
          url: "/hire-react-native-developers.html",
          iconclass: "react-native",
          tech: "React Native",
        },

        {
          url: "/hire-flutter-app-developers.html",
          iconclass: "flutter",
          tech: "Flutter",
        },
        {
          url: "/hire-xamarin-app-developers.html",
          iconclass: "xamrin",
          tech: "Xamarin",
        },
      ],
      pageurl: "/mobile-application-development.html",
    },
    {
      tabId: "tab2",

      title: " <span class='text-primary'>Frontend </span>development",
      smalltitle: "Build & nurture  top-notch user experiences",
      des: "Our <a href='/frontend-development.html' class='text-primary'>front-end development</a> team handles diverse UI challenges, providing solutions that enhance usability and engagement. We have expertise in advanced tools & technologies for creating responsive web apps that perform seamlessly across devices. Whether it's about understanding user needs or solving challenges, our web application development team makes sure to address & improve the overall user experience effectively.",
      list: [
        {
          url: "/hire-angular-developers.html",
          iconclass: "angular",
          tech: "Angular",
        },
        {
          url: "/hire-react-developers.html",
          iconclass: "react",
          tech: "React",
        },
        {
          url: "/hire-vuejs-developers.html",
          iconclass: "vue-js",
          tech: "Vue.JS",
        },
        {
          // url: "https://www.thinkodc.com/hire-html-css-developers",
          iconclass: "html-5",
          tech: "HTML5",
        },
        {
          // url: "https://www.thinkodc.com/hire-javascript-developers",
          iconclass: "java-script",
          tech: "JavaScript",
        },
        {
          iconclass: "type-script",
          tech: "TypeScript",
        },
      ],
      pageurl: "/frontend-development.html",
    },
    {
      tabId: "tab3",
      title: " <span class='text-primary'>Backend</span> development",
      smalltitle: "Complete automation for your requirements",
      des: "Build secure back-end solutions that handle data processing, business logic, and API integration with ease. The immense technical expertise of our back-end developers helps you design robust & scalable architectures using the latest programming languages and frameworks—partner with us to build high-performance <a class='text-primary' href='/web-application-development.html'>web applications</a> and exceptional server-side solutions.",
      list: [
        {
          url: "/hire-nodejs-developers.html",
          iconclass: "node-js",
          tech: "Node.js",
        },
        // {
        //   url: "/hire-laravel-developer.html",
        //   iconclass: "laravel",
        //   tech: "Laravel",
        // },
        {
          url: "/hire-python-developers.html",
          iconclass: "python",
          tech: "Python",
        },
        {
          url: "/hire-dot-net-developers.html",
          iconclass: "dot-net",
          tech: ".Net",
        },
        {
          url: "/hire-java-developers.html",
          iconclass: "java",
          tech: "Java",
        },
        {
          url: "/hire-php-developers.html",
          iconclass: "php",
          tech: "PHP",
        },
      ]
    },
    {
      tabId: "tab4",
      title: " <span class='text-primary'>Database</span> development",
      smalltitle: "Effortless big data management",
      des: "As a leading enterprise software development company we understand the importance of managing data in business growth. By implementing top tools & best practices for data management we make sure your data access, organization, storage, and data security are kept on high priority. Our database technology experts help you harness the power of your data to make informed decisions and fuel your growth.",
      list: [
        {
          url: "/hire-mongodb-developers.html",
          iconclass: "mongo-db",
          tech: "MongoDB",
        },
        {
          iconclass: "redis",
          tech: "Redis",
        },
        {
          iconclass: "postgre-sql",
          tech: "PostgreSQL",
        },
        {
          iconclass: "my-sql",
          tech: "MySQL",
        },
        {
          iconclass: "elasticsearch",
          tech: "Elasticsearch",
        },
      ]
    },
    {
      tabId: "tab5",
      title: " <span class='text-primary'>Cloud</span> services",
      smalltitle: "Migrate to a modern future of cloud",
      des: "Our cloud development technology stack is filled with expertise that helps you harness the power of cloud computing. Our cloud experts are capable of offering scalable and flexible solutions that adapt to your evolving needs. By utilizing the leading cloud platforms, our cloud engineers ensure your applications are secure, reliable, and available anytime, anywhere. Let us help you transition to the cloud and bring new opportunities for innovation.",
      list: [
        {
          imgicon: Imageicon1,
          tech: "Amazon ECS/EKS"
        },
        {
          imgicon: Imageicon2,
          tech: "AWS Lambda",
        },
        {
          imgicon: Imageicon3,
          tech: "AWS CloudFormation",
        },
        // {
        //   imgicon: Imageicon4,
        //   tech: "AWS CloudWatch",
        // },
        {
          imgicon: Imageicon5,
          tech: "AWS IAM",
        },
        {
          imgicon: Imageicon6,
          tech: "Amazon CloudFront",
        }
      ]
    },
    {
      tabId: "tab6",
      title: " <span class='text-primary'>DevOps</span> services",
      smalltitle: "Manage development & operations effectively",
      des: "Power up your software development lifecycle(SDLC) with our DevOps expertise. Our skilled team utilizes the latest tools and technologies to streamline your development & operations. We prioritize automation to create faster and more reliable software delivery. Our DevOps consulting team ensures best practices in CI/CD pipelines that help in cutting down on errors and encourage teamwork, optimizing workflows, and enhancing software quality.",
      list: [
        {

          imgicon: Imageicon7,
          tech: "Jenkins",
        },

        {
          imgicon: Imageicon8,

          tech: "Github Actions",
        },
        {

          imgicon: Imageicon9,

          tech: "Terraform",
        },
        {

          imgicon: Imageicon10,

          tech: "Docker",
        },
        {

          imgicon: Imageicon11,

          tech: "Grafana",
        },
        {

          imgicon: Imageicon12,

          tech: "SonarQube",
        },
      ]
    },
    {
      tabId: "tab7",
      title: "<span class='text-primary'>AI development</span> services",
      smalltitle: "Revolutionize business with advanced AI solutions",
      des: "Supercharge your operations with our AI development expertise. Our team utilizes the latest technologies to transform your workflows with intelligent automation, data-driven insights, and seamless AI integration. From building secure AI chatbots to deploying generative AI and machine learning models, our AI experts deliver custom solutions focusing on NLP, computer vision, and RPA leading to smarter decision-making, improved efficiency, and exceptional user experiences.",
      list: [
        {
          imgicon: Imageicon13,
          tech: "OpenAI",
        },
        {
          imgicon: Imageicon14,
          tech: "AWS Bedrock",
        },
        {
          imgicon: Imageicon15,
          tech: "AWS Lex",
        },
        {
          imgicon: Imageicon16,
          tech: "AWS Textract ",
        },
        {
          imgicon: Imageicon17,
          tech: "AWS Transcribe",
        }
      ]
    },
  ]


  const step = [
    {
      num: "01",
      iconclass: "zmdi-file-text",
      title: "Discuss & plan requirements",
      desc: "Engage clients to clarify the project’s vision and goals through brainstorming sessions."
    },
    {
      num: "02",
      iconclass: "zmdi-account",
      title: "Shortlist developers",
      desc: "Assess & evaluate potential developers based on the requirements discussed in initial planning to create a qualified shortlist."
    },
    {
      num: "03",
      iconclass: "zmdi-accounts",
      title: "Finalize your team",
      desc: "Shortlist and finalize the team based on needs and commitment to the project."
    },
    {
      num: "04",
      iconclass: "zmdi-desktop-mac",
      title: "Onboard the team",
      desc: "The offshore team is effectively onboarded for the project."
    },
    {
      num: "05",
      iconclass: "zmdi-assignment",
      title: "Begin project",
      desc: "Finally, developers begin working(within 2 weeks of initial discussion) and maintain open communication for consistent progress."
    }
  ]
  const outsourceservice = [


    {
      title: "Custom Software development",
      des: "Bring your vision to reality with our <a href='/software-development-services.html' class='text-primary'>custom software development services</a>. Under the expertise of our proficient team skilled in frameworks, programming languages, development tools & more you can go crazy with your ideas, while we turn them into a successful solution.",
      mainlnk: "/software-development-services.html",
      mainlinktext: "Develop software", img: Index1

    },
    {
      title: "Digital Transformation",
      des: "Evolve faster and grab future opportunities today with our <a href='/digital-transformation.html' class='text-primary'>digital transformation</a> services. Our strategic and unique digital transformation approach helps businesses transform and drive fundamental change.",
      mainlnk: "/digital-transformation.html",
      mainlinktext: "Get digital or Modernize business",
      img: Index5
    },
    {
      title: "Resource as a Service",
      des: "Expand your team and scale your solutions with our top 1% talent pool. Undergoing regular tests and committing to high coding standards we offer you pre-vetted <a href='/hire-dedicated-developers.html' class='text-primary'>offshore developers</a> who can create, fix, and deliver world-class products always on time. ",
      mainlnk: "/hire-dedicated-developers.html",
      mainlinktext: "Build your team",
      img: Index6

    },
    {
      title: "Product engineering",
      des: "Get the latest innovative technology with our <a href='/product-engineering-services.html' class='text-primary'>product engineering </a> services From upgrading human experience to building innovative digital products, we engineer custom IT solutions that power up your business expertise and improve growth. ",
      mainlnk: "/product-engineering-services.html",
      mainlinktext: "Engineer products",
      img: Index4
    },
    {
      title: "Cloud & DevOps services",
      des: "Tackle infrastructure challenges with our expert <a href='/cloud-services-and-solutions.html' class='text-primary'>cloud solutions</a> and <a href='/devops-services.html' class='text-primary'>DevOps services</a>. From CI/CD automation to serverless architecture, we deliver scalable, innovative solutions to optimize operations and drive your business forward.",
      img: Index2,
      mainlnk: "/cloud-services-and-solutions.html",
      mainlinktext: "Get power of cloud solutions",
    },
    // {
    //   title: "DevOps Services",
    //   des: "Peerbits is a foward-thinking company where we always keep up with the evolving next-gen IT innovations. Our future-led <a href='/devops-services.html' class='text-primary'>DevOps services</a> offer—DevOps consulting, CI/CD, automation, serverless architecture, and microservices.",
    // keyname: "keyname",
    // sub: [
    //   {
    //     tooltip1: "DevOps Consulting",
    //     link1: "/devops-consulting-services.html",
    //     iconclass1: "cloud-consulting"
    //   },
    //   {
    //     tooltip1: "DevOps CI/CD",
    //     link1: "/devops-ci-cd-services.html",
    //     iconclass1: "cloud-migration"
    //   },
    //   {
    //     tooltip1: "DevOps Automation",
    //     link1: "/devops-automation-services.html",
    //     iconclass1: "cloud-optimisation"
    //   },
    // ],
    //   mainlnk: "/devops-services.html",
    //   mainlinktext: "Explore services",
    //   img: Index3
    // },




    // {
    //   title: "IoT",
    //   des: "Developing smart IoT apps to simplify, improve, & automate business by connecting physical to digital, reducing cost.",
    //   mainlnk: "/internet-of-things-iot-applications-development-company.html",
    //   mainlinktext: "Build smart apps"
    // },


    // {
    //   title: "Chatbot",
    //   des: "Drive promising business growth with our AI-powered chatbots. Streamline business processes & enhance your customer satisfaction with our innovative chatbot solutions.",

    // },


    {
      title: "AI development services",
      des: "Transform your businesses with our next-gen <a href='/ai-development-services.html' class='text-primary'>AI solutions</a>. From data management to automation, we utilize RAG, generative AI, and machine learning to streamline operations, unlock insights, and create smarter, scalable systems for your modern challenges.",
      img: Index7,
      mainlnk: "/cloud-services-and-solutions.html",
      mainlinktext: "Get power of cloud solutions",
    },
  ]
  const flipdata = [
    {
      iconclass: "healthcare",
      title: "Healthcare",
      des: "Healthcare SaaS platform, Telemedicine app, mHealth apps, & other healthcare software development solutions",
      backtitle: "Healthcare",
      backdes: "Peerbit’s software developers experience in healthcare, designs software solutions that adhere to necessary compliance regulations, with the goal of enhancing patient outcomes, facilitating remote care, and streamlining medical workflows through automation.",
      link: "/healthcare-software-development.html",
      linktext: "Explore our healthcare expertise"
    },
    {
      iconclass: "finance",
      title: "Fintech",
      des: "Fintech SaaS platforms, Mobile wallet apps, Neobank apps, & other financial software development solutions.",
      backtitle: "Fintech",
      backdes: "We combine our technical skills with knowledge of finance to develop a diverse FinTech solution that enhances the transactional process, following necessary security compliances-leading to a significant increase in market share.",
      link: "/financial-software-development.html",
      linktext: "Transform your finances"
    },
    {
      iconclass: "logistics",
      title: "Logistics",
      des: "Logistics SaaS solutions, Route optimization software, Freight management apps, & other logistics software development solutions.",
      backtitle: "Logistics",
      backdes: "Our industry experience in logistics software development enables us to build a scalable system & secure transportation operations for the evolving needs. We ensure to improve the overall profitability of your logistics business.",
      link: "/logistics-software-development.html",
      linktext: "Optimize your logistics"
    },
    {
      iconclass: "manufacturing",
      title: "Manufacturing",
      des: "Manufacturing SaaS solutions, Supply chain management software, IoT-enabled production apps, & other manufacturing software development solutions.",
      backtitle: "Manufacturing",
      backdes: "Our team of software developers deliver innovative solutions for manufacturing industry that optimize their production efficiency, streamline supply chain management, and use IoT technology to enhance operational workflows.",


    },
    {
      iconclass: "retail",
      title: "Retail",
      des: "Retail SaaS platforms, E-commerce solutions, Inventory management systems, & other retail software development solutions.",
      backtitle: "Retail",
      backdes: "We specialise in creating dynamic solutions that elevate the customer experience, optimize inventory management, and integrate e-commerce functionalities supporting you in boosting sales and expanding market presence.",
      link: "/retail-mobility-solutions.html",
      linktext: "Boost your retail performance"
    },
    {
      iconclass: "automative",
      title: "Automotive",
      des: "Automotive SaaS solutions, Fleet management software, Vehicle telematics apps, & other automotive software development solutions.",
      backtitle: "Automotive",
      backdes: "Our automotive software development experts design integrated solutions that enhance fleet efficiency, provide real-time vehicle insights through telematics, and improve overall operational workflows, positioning your business for ultimate growth."
    },
  ]
  const accordian = [
    {
      title: "What development methodologies do you follow?",
      des: "As the best software development company, we prioritize working with Agile and Scrum methodologies that make our projects adaptable and responsive to client needs. The ongoing evaluation and adjustments through regular sprints and feedback sessions also get easier with these approaches.<br> <br>Additionally, we also utilize <a class='text-primary' href='/blog/ultimate-guide-to-devops-principles-woks-and-examples.html'>DevOps practices</a> to automate and streamline processes between our development and operations teams. It helps us maintain high-quality standards and meet the client's expectations."
    },
    {
      title: "Can you deliver custom software based on my timeline?",
      des: "Yes, we collaborate with you to get a precise understanding of your goals. Our skilled team addresses your needs and deadlines to create development plans and assign tasks. It ensures your project is completed on time and meets your vision."
    },
    {
      title: "What is the estimated cost for my software development project?",
      des: "On a standard basis, software development costs for a medium-to-large application range between $50,000 to $1,000,000. Further, the cost will depend on the custom UI design, number of integrations with other software systems, security, performance requirements, and amount & complexity of features you plan to implement in your software project."
    },
    {
      title: "What is the cost of hiring developers from Peerbits?",
      des: "Peerbits offers competitive rates starting at $15/hour for hiring offshore developers. For more information regarding flexibility and responsibility breakdowns, you can refer to our <a class='text-primary' href='/engagement-model.html'>engagement models</a>."
    },
    {
      title: "Who owns the code once the software project is completed?",
      des: "You will have full ownership of the code including a fully signed NDA, top code security, easy exit policy, and simple transparent pricing on project completion."
    },
    {
      title: "How do you control the quality of the software you deliver?",
      des: "Peerbits chooses a shift-left approach for the <a class='text-primary' href='/blog/quality-assurance-process-peerbits.html'>quality assurance</a> of your software solutions.  We prioritize quality from the very beginning of the development process, allowing us to identify and address issues early, ultimately delivering a more reliable and efficient product."
    },
    {
      title: "How do you ensure the privacy & confidentiality of our projects?",
      des: "As the top software development agency we highly prioritize the security & quality of software. We secure your project’s privacy with NDAs, secure protocols, compliance standards, and strict confidentiality agreements."
    },
    {
      title: "Which standards and regulations do you follow as a software development company?",
      des: "A secure development process must follow the right standards, laws, and regulations. At Peerbits, we create software solutions for clients in different countries and industries. For instance, when working with healthcare, we make sure to meet HIPAA, CFR, GDPR, FHIR, and HL7 requirements. We also help our clients get ONC Health IT certification. In the FinTech sector, we comply with PCI-DSS, PSD2, SOC2, and GDPR."
    },
  ]
  const TeamBehind = [
    {
      title: "Software engineers",
      desc: "Hire skilled offshore software engineers holding immense expertise in a variety of OS, iOS, Android, and Windows platforms.",
      keyname: "img1"
    },
    {
      title: "Project manager",
      desc: "Employ an offshore project manager to oversee project direction and guarantee alignment with business goals.",
      keyname: "img2"
    },
    {
      title: "QA engineers",
      desc: "Utilize offshore quality analysts from Peerbits to maintain high-quality coding standards and resolve software issues efficiently.",
      keyname: "img3"
    },
    {
      title: "Designers",
      desc: "Get offshore UI/UX designers to bring creative visions to life for making user-friendly and visually appealing products.",
      keyname: "img4"
    },
  ]
  return (
    <>
      <Layout>
        <section className='section min-vh-100 d-flex flex-column home-background-pattern'>
          <LazyLoad>
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: -1
              }}
            >
              <Animations animation={BannerImg} />
            </div>
          </LazyLoad>
          <LazyLoad>
            <StaticImage
              style={{ position: 'absolute' }}
              className='section-background-image'
              loading='lazy'
              src={HomeBannerShadow}
              alt='Home banner pattren'
            />
          </LazyLoad>
          {/* <div style={{
            position: 'absolute',
            bottom: -15,
            left: -15,
            zIndex: -1,
            width: "50%",
            transform: "rotate(90deg)"
          }}>
            <Animations animation={BannerImg} />
          </div>
          <div style={{
            position: 'absolute',
            top: -15,
            right: -15,
            zIndex: -1,
            width: "50%",
            transform: "rotate(-90deg)"
          }}>
            <Animations animation={BannerImg} />
          </div> */}
          <Container className='my-auto d-flex flex-column py-5 text-center'>
            <h1 className='sub-title mb-3'>
              CUSTOM SOFTWARE DEVELOPMENT COMPANY
            </h1>
            <h2 className='mb-4 font-size-64'>
              Turning challenges into{' '} opportunities with <span className='text-primary'>custom software</span>
            </h2>
            <p className='lead mb-0 max-width-950 mx-auto'>
              Peerbits creates secure and scalable software solutions to solve business challenges. As a visionary software development company we aim to accelerate digital transformation with our next-gen expertise. Build innovative software solutions that leave a lasting impact on your industry.
            </p>
            <div className="mt-4 mt-lg-5">
              <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme m-1 mx-2">
                Transform business now
              </Link>
              <AnchorLink to="#casestudy" className="btn btn-lg btn-primary-theme-outline m-1 mx-2">
                Our work highlights
              </AnchorLink>

            </div>
            {/* <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline mt-4">
                Build Your Team
              </Link> */}
          </Container>
        </section>
        {/* <Suspense fallback={<div>Loading...</div>}> */}
        <OurClients sectionClass="bg-light" title="Trusted <span class='text-primary'>clients</span> we’re proud of" description="Peerbits has partnered with clients worldwide to deliver top-notch custom software solutions. Discover clients who rely on our offshore software development team for impactful results." />
        {/* </Suspense> */}

        {/* <section className='section section-background bg-black gradient-box'>
          <Container className='py-5'>
            <div className='mb-5 pb-1 max-width-950'>
              <h2 className='heading mb-4 text-white '>
                Empower your vision with our <span className='text-primary'>software development services</span>
              </h2>
              <p className='lead text-white-75'>
                At Peerbits, we aim to simplify your software challenges with our custom software solutions. Whether you need basic software or a comprehensive solution for a massive project, our software development services support you at every end. We ensure you bring ideas to the digital world & thrive seamlessly.
              </p>
            </div>
            <Row className='g-4' xs={1} sm={1} md={2} lg={3}>
              {
                outsourceservice.map((item, index) => (
                  <Col key={index}>
                    <div className='dark-box-2 equal-height d-flex flex-column'>
                      <h3 className=' mb-3 font-size-24 text-white'>
                        {item.title}
                      </h3>
                      <p className={`${(index === 3 || index === 4 || index === 5 || index === 6) ? "" : "mb-4"}`}>
                        {item.des}
                      </p>
                      {
                        item.keyname ?
                          <div className='mb-3'>
                            <Row className='g-3' xs={3} sm={4} lg={3} xl={4} xxl={6}>
                              {

                                item.sub.map((item, index) => (
                                  <Col className='text-center' key={index}>
                                    <OverlayTrigger
                                      placement='top'
                                      overlay={<Tooltip>{item.tooltip1}</Tooltip>}
                                    >
                                      {
                                        item.link1 ?
                                          <Link
                                            to={item.link1}
                                            aria-label={item.tooltip1}
                                            className=' force-hover d-inline-block'
                                          >
                                            <i className={`technologies-sprite-icon ${item.iconclass1} icon-size-50`} >
                                            </i>
                                          </Link> :
                                          <div className=' d-inline-block'>
                                            <i className={`technologies-sprite-icon ${item.iconclass1} icon-size-50`}></i>
                                          </div>
                                      }
                                    </OverlayTrigger>
                                  </Col>
                                ))

                              }
                            </Row>
                          </div> :
                          null
                      }
                      {
                        item.mainlinktext ?
                          <div className='text-start mt-auto'>
                            <Link
                              to={item.mainlnk ? item.mainlnk : null}
                              className='btn btn-link px-0'
                            >
                              <span>{item.mainlinktext}</span>{' '}
                              <i className='icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right'></i>
                            </Link>
                          </div> :
                          null
                      }
                    </div>
                  </Col>
                ))
              }
            </Row>
          </Container>
          <LazyLoad>
            <StaticImage
              style={{ position: 'absolute' }}
              className='section-background-image'
              loading='lazy'
              src={CTABgDark}
              alt='Home banner pattren'
            />
          </LazyLoad>
        </section> */}
        <section className='section bg-light'>
          <Container className='py-5'>
            <div className='mb-5 pb-1 max-width-950'>
              <h2 className='heading mb-4'>
                Empower your vision with our <span className='text-primary'>software development services</span>
              </h2>
              <p className='lead'>
                At Peerbits, we aim to simplify your software challenges with our custom software solutions. Whether you need basic software or a comprehensive solution for a massive project, our software development services support you at every end. We ensure you bring ideas to the digital world & thrive seamlessly.
              </p>
            </div>
            <Row className='g-5' xs={1} sm={1} md={2} lg={3}>
              {
                outsourceservice.map((item, index) => (
                  <Col key={index}>
                    <div className='equal-height d-flex flex-column'>
                      <div className="icon mb-4">
                        <Image loading="lazy" width={40} height={40} className="lazyload" src={item.img} alt="TechnologiesIcon" />
                      </div>

                      <h3 className=' mb-3 font-size-24'>
                        {item.title}
                      </h3>
                      <p className="mb-0" dangerouslySetInnerHTML={{ __html: item.des }} >
                      </p>
                      {/* {
                        item.keyname ?
                          <div className='mb-3'>
                            <Row className='g-3' xs={3} sm={4} lg={3} xl={4} xxl={6}>
                              {

                                item.sub.map((item, index) => (
                                  <Col className='text-center' key={index}>
                                    <OverlayTrigger
                                      placement='top'
                                      overlay={<Tooltip>{item.tooltip1}</Tooltip>}
                                    >
                                      {
                                        item.link1 ?
                                          <Link
                                            to={item.link1}
                                            aria-label={item.tooltip1}
                                            className=' force-hover d-inline-block'
                                          >
                                            <i className={`technologies-sprite-icon ${item.iconclass1} icon-size-50`} >
                                            </i>
                                          </Link> :
                                          <div className=' d-inline-block'>
                                            <i className={`technologies-sprite-icon ${item.iconclass1} icon-size-50`}></i>
                                          </div>
                                      }
                                    </OverlayTrigger>
                                  </Col>
                                ))

                              }
                            </Row>
                          </div> :
                          null
                      }
                      {
                        item.mainlinktext ?
                          <div className='text-start mt-auto'>
                            <Link
                              to={item.mainlnk ? item.mainlnk : null}
                              className='btn btn-link px-0'
                            >
                              <span>{item.mainlinktext}</span>{' '}
                              <i className='icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right'></i>
                            </Link>
                          </div> :
                          null
                      } */}
                    </div>
                  </Col>
                ))
              }
            </Row>
            <div className="pt-5 mt-4 text-center">
              <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline">
                Let's discuss my project
              </Link>
            </div>
          </Container>

        </section>

        <section className="section">
          <Container className="py-5">
            <Row className="g-5" xs={1} md={1}>
              <Col lg={5}>
                <div className="mb-5 pb-1 sticky-section">
                  <h2 className="mb-4">
                    <span className="text-primary">Technologies</span> we use for custom solutions
                  </h2>
                  <p className="lead mb-4">
                    We solve your complex challenges and optimize workflows through our <Link className="text-primary" to="technology-stack.html">advanced technology expertise</Link>. Our talented experts utilize the best tools for your projects that deliver scalable, efficient, and future-ready solutions. Check out our technical capabilities in detail.
                  </p>
                  <Scrollspy offset={-500} className="list-unstyled left-line-list mb-5" items={['tab1', 'tab2', 'tab3', 'tab4', 'tab5', 'tab6', 'tab7']} currentClassName="active">
                    <li className="active">
                      <AnchorLink to="#tab1">
                        Mobile app development
                      </AnchorLink>
                    </li>
                    <li>
                      <AnchorLink to="#tab2">
                        Frontend development
                      </AnchorLink>
                    </li>
                    <li>
                      <AnchorLink to="#tab3">
                        Backend development
                      </AnchorLink>
                    </li>
                    <li>
                      <AnchorLink to="#tab4">
                        Database development
                      </AnchorLink>
                    </li>
                    <li>
                      <AnchorLink to="#tab5">
                        Cloud services
                      </AnchorLink>
                    </li>
                    <li>
                      <AnchorLink to="#tab6">
                        DevOps services
                      </AnchorLink>
                    </li>
                    <li>
                      <AnchorLink to="#tab7">
                        AI development services
                      </AnchorLink>
                    </li>
                  </Scrollspy>

                </div>
              </Col>
              <Col className="text-lg-center" lg={7}>
                {
                  ReliableOffshore.map((item, index) => (
                    <div className={`dark-box-2 border d-flex flex-column text-start ${index === 6 ? "mb-0" : "mb-4"}`} key={index} id={item.tabId} >
                      <h3 className="font-size-28 mb-4" dangerouslySetInnerHTML={{ __html: item.title }} />

                      <h4 className="mb-3">{item.smalltitle}</h4>
                      <p className={`${(index === 4 || index === 5) ? "mb-4" : "mb-4"} `} dangerouslySetInnerHTML={{ __html: item.des }}></p>
                      <div className="mb-0">
                        <Row xs="auto" className="g-4">
                          {
                            item?.list?.map((item, index) => (

                              <Col className="text-center" key={index} >
                                {
                                  item.url ?
                                    <Link to={item.url} className="text-body force-hover d-inline-block">
                                      {
                                        item.iconclass ?
                                          <i className={`technologies-sprite-icon ${item.iconclass} icon-size-60 mb-2`}></i> :
                                          null
                                      }

                                      <p className="mb-0 font-size-14">{item.tech}</p>
                                    </Link> :
                                    <div className="d-inline-block">

                                      {
                                        item.imgicon ?
                                          <Image loading="lazy" width={60} height={60} className="lazyload mb-2" src={item.imgicon} alt="TechnologiesIcon" /> :
                                          <i className={`technologies-sprite-icon ${item.iconclass} icon-size-60 mb-2`}></i>
                                      }
                                      <p className="mb-0 font-size-14">{item.tech}</p>
                                    </div>
                                }
                              </Col>
                            ))
                          }

                        </Row>
                      </div>
                      {/* {
                        item.pageurl ?
                          <Link to={item.pageurl} className="btn btn-link px-0 text-start mt-auto">
                            <span>Learn More</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                          </Link> :
                          null
                      } */}
                    </div>
                  ))
                }
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section bg-black section-background">
          <Container className="py-5">

            <Row className="g-5" xs={1} lg={2}>
              <Col>
                <div className="sticky-section">
                  <h2 className="mb-4 text-white">Hiring simplified: Connect with developers for your <span className="text-primary">custom solutions</span></h2>
                  <p className="lead text-white-75 mb-0">Peerbits’ strategic planning and easy-to-hire models simplify software development. Here is our seamless process for hiring offshore developer(s) for your custom solutions.</p>
                  <Link to="/request-quote.html" className="btn btn-primary-theme btn-lg mt-5">Shape your team</Link>
                </div>
              </Col>
              <Col>
                <ul className="list-unstyled step-by-step-process">
                  {
                    step?.map((item, index) => (
                      <li key={index} className="d-flex">
                        <div className="number me-4 icon-size-50 bg-primary rounded-circle text-white">
                          {/* {index + 1} */}
                          <i className={`zmdi ${item.iconclass} zmdi-hc-fw zmdi-hc-lg font-size-24`}></i>
                        </div>
                        <div className="flex-fill">
                          <p className="sub-title mb-1 text-white opacity-50 fw-medium">STEP {index + 1}</p>
                          <h3 className="mb-3 text-white font-size-24">{item.title}</h3>
                          <p className="text-white-75 mb-0">{item.desc}</p>
                        </div>
                      </li>
                    ))
                  }
                  {/* <li className="d-flex step-by-step-process-action">
                    <div className="number me-4 icon-size-50"></div>
                    <div className="flex-fill">
                      <Link to="/request-quote.html" className="btn btn-primary-theme btn-lg">Shape your team</Link>
                    </div>
                  </li> */}
                </ul>
              </Col>
            </Row>
          </Container>
          <LazyLoad>
            <StaticImage
              style={{ position: 'absolute' }}
              className='section-background-image'
              loading='lazy'
              src={CTABgDark}
              alt='Background pattren'
            />
          </LazyLoad>
        </section>
        <section className="section ">
          <Container className="py-5">
            <div className="mb-5 pb-1">
              <div className="section-title ">
                <h2 className="heading fw-semibold mb-4">
                  Build your <span className="text-primary"  >offshore development</span> team today!
                </h2>
                <p className="lead mb-0 max-width-950">
                  Peerbits offers a large pool of pre-vetted top 1% talent who excel in their respective fields and deliver top-notch IT solutions on time. Based on your project requirements, easily hire offshore teams and achieve impactful results.
                </p>
              </div>
            </div>
            <Row className="g-4" xs={1} md={2} lg={4}>
              {TeamBehind?.map((item, index) => (
                <Col key={index}>
                  <div className="leader-box font-size-16 text-center">
                    <div className="leader-box-image mb-4">
                      {
                        item.keyname === "img1" ?
                          <LazyLoad offsetVertical={1000}>
                            <StaticImage loading="lazy" src={Image1} width={220} height={220} alt="Team-Software" />
                          </LazyLoad> :
                          null
                      }
                      {
                        item.keyname === "img2" ?
                          <LazyLoad offsetVertical={1000}>
                            <StaticImage loading="lazy" src={Image2} width={220} height={220} alt="Team-Project-manager" />
                          </LazyLoad> :
                          null
                      }
                      {
                        item.keyname === "img3" ?
                          <LazyLoad offsetVertical={1000}>
                            <StaticImage loading="lazy" src={Image3} width={220} height={220} alt="Tapan" />
                          </LazyLoad> :
                          null
                      }
                      {
                        item.keyname === "img4" ?
                          <LazyLoad offsetVertical={1000}>
                            <StaticImage loading="lazy" src={Image4} width={220} height={220} alt="Tapan" />
                          </LazyLoad> :
                          null
                      }
                    </div>
                    <div>
                      <h3 className="h4">{item.title}</h3>
                      <p className="mb-0">{item.desc}</p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
        <section className='section bg-light'>
          <Container className='py-5'>
            <div className='mb-4 pb-1'>
              <h2 className='mb-4 '>
                Our global <span className='text-primary'>industry</span> footprint
              </h2>
              <p className=' max-width-950  lead'>
                Peerbits has gained experience in a wide range of industries enabling us to provide top-notch software solutions with valuable insights.
              </p>
            </div>
            <Row as="ul" xs={1} md={2} lg={3} className="list-unstyled industries-flip-hover-box g-4">
              {
                flipdata.map((item, index) => (
                  <Col as="li" key={index}>


                    {

                      item.link ?
                        <Link to={item.link} className="flip-card dark-box-2 p-0 rounded-3 equal-height">
                          <div className="flip-card-inner">
                            <div className="flip-card-front p-4">
                              <i className={`mobile-application-sprite-icon ${item.iconclass} icon-size-70 mb-3`}></i>
                              <h3 className="h4  mb-3">{item.title}</h3>
                              <p className="text mb-0">{item.des}</p>
                            </div>

                            <div className="flip-card-back p-4">
                              <h3 className="h4  mb-3">{item.backtitle}</h3>
                              <p>{item.backdes}</p>
                              <span className="btn btn-link px-0">
                                <span>{item.linktext}</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                              </span>
                            </div>

                          </div>
                        </Link> :
                        <div className="flip-card dark-box-2 p-0 rounded-3 equal-height">
                          <div className="flip-card-inner">
                            <div className="flip-card-front p-4">
                              <i className={`mobile-application-sprite-icon ${item.iconclass} icon-size-70 mb-3`}></i>
                              <h3 className="h4  mb-3">{item.title}</h3>
                              <p className="text mb-0">{item.des}</p>
                            </div>

                            <div className="flip-card-back p-4">
                              <h3 className="h4  mb-3">{item.backtitle}</h3>
                              <p className="mb-0">{item.backdes}</p>
                              {/* <span className="btn btn-link px-0">
                                <span>{item.linktext}</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                              </span> */}
                            </div>

                          </div>
                        </div>
                    }
                  </Col>
                ))
              }
            </Row>
          </Container>
        </section>
        {/* <section className="section bg-black section-background">
          <Container>
            <Row xs={1} md={2} lg={2} className="g-4 align-items-center">
              <Col xxl={6}>
                <h2 className="heading mb-4 text-white">
                  Empowering your success with <span className="text-primary">unmatched quality</span>
                </h2>
                <p className="lead text-white-75">Get the solution you need, with the quality you can rely on!</p>
                <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline mt-4">
                  Let’s get started
                </Link>
              </Col>
              <Col xxl={6} className="text-center">
                <LazyLoad><StaticImage loading="lazy" src={CtaImg} alt="home-cta-img" width={544} height={382} /></LazyLoad>
              </Col>
            </Row>
          </Container>
          <LazyLoad>
            <StaticImage
              style={{ position: 'absolute' }}
              className='section-background-image'
              loading='lazy'
              src={CTABgDark}
              alt='Background pattren'
            />
          </LazyLoad>
        </section> */}
        <section className="section bg-black section-background">
          <Container className="py-5">
            <div className="text-center max-width-1000 mx-auto">
              <h2 className="heading mb-4 text-white">Empowering your success with <span className="text-primary">unmatched quality</span>
              </h2>
              <p className="lead text-white-75" >Get the solution you need, with the quality you can rely on!
              </p>
              <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline mt-4">
                Let’s get started
              </Link>
            </div>
          </Container>
          <LazyLoad>
            <StaticImage
              style={{ position: 'absolute' }}
              className='section-background-image'
              loading='lazy'
              src={CTABgDark1}
              alt='Home banner pattren'
            />
          </LazyLoad>
        </section>
        {/* <Suspense fallback={<div>Loading...</div>}> */}
        <ClientsTestimonial
          title='Valued feedback from  <span class="text-primary"> our clients</span>'
          description="Don’t just take our word for it, hear the experiences of our clients. As a leading custom software development company we make sure our clients receive the best products and it precisely delivers the founder’s vision."
          sectionClass='bg-white'
        />
        <div id="casestudy">
          {/* <Suspense fallback={<div>Loading...</div>}> */}
          <LazyLoad offset={300}>

            <CaseStudy
              title="<span class='text-primary'>Case study:</span> Our portfolio of success"
              description="Discover how our enterprise software development strives with integrity towards making our client's project a success story."
              // category='Social, Healthcare & Fitness'
              // specificTitle={specificTitle}
              sectionClass='bg-light'
            />
          </LazyLoad>
          {/* </Suspense> */}
        </div>
        <section className="section ">
          <Container className="py-5">
            <div className="mb-5 pb-1">
              <h2 className="mb-4">
                Why we stand out as a <span className="text-primary">software development company?</span>
              </h2>
              <p className="max-width-950 lead">Surely numbers & figures can say a lot but we prioritize quality over everything. Our high coding standards, constant growth, and passion for innovation at our software development agency, always make us stand out. For a deeper look, here's what makes us a perfect choice for custom software solutions.</p>
            </div>
            <WhyChooseFacts />
            <Row className="g-4 hover-box" xs={1} md={2} lg={3}>
              {
                choosedata.map((item, index) => (
                  <Col key={index}>
                    <div className="dark-box-2 center-icon-box equal-height">
                      <div className="icon icon-size-70 mb-4">
                        <LazyLoad offset={150}>
                          <Animations animation={item.icon} />
                        </LazyLoad>
                      </div>
                      <h3 className="h4 mb-3">{item.title}</h3>
                      <p className="">{item.des}</p>
                    </div>
                  </Col>
                ))
              }
            </Row>
            {/* <div className="pt-5 mt-4 text-center">
              <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline">
                Build a successful software
              </Link>
            </div> */}
          </Container>
        </section>
        {/* </Suspense> */}
        {/* <Suspense fallback={<div>Loading...</div>}>
          <Facts sectionClass='bg-light' />
        </Suspense> */}

        {/* <Suspense fallback={<div>Loading...</div>}> */}
        <LazyLoad offset={300}>
          <Awards sectionClass='bg-light' title="Awards, accolades, and recognition received by <span class='text-primary'>Peerbits</span>" description="Over the years of innovation, we have supported numerous startups and businesses with high-quality enterprise software development services. Our dedication to excellence has earned us several awards and recognitions." />
        </LazyLoad>
        {/* </Suspense> */}



        <Faqs accordian={accordian} sectionClass="bg-white" />

        {/* <Suspense fallback={<div>Loading...</div>}> */}
        <LazyLoad offset={300}>
          <BlogList
            sectionClass="bg-light"
          // category='Angular, Hire developer'
          />
        </LazyLoad>
        {/* </Suspense> */}

      </Layout >
    </>
  )
}

export default IndexNewPage
